<template>
  <a-modal
    class="company-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="visible"
    title="反馈信息"
    :footer="null"
    @cancel="$emit('onCancel')"
  >
    <div class="feedbackwrapper">
      <a-row v-if="feedbackData.before_list.length>0">
        <a-col
          :span="6"
          class="feed-title"
        >
          调研报告
        </a-col>
        <a-col
          :span="18"
        >
          <div
            v-for="(option,index) in feedbackData.before_list"
            :key="option.id"
            class="questionItem"
          >
            <div class="question">
              {{ index + 1 }}.{{ option.survey_name }}
            </div>
            答案：<span class="answer">{{ option.answer.join('、') }}</span>
          </div>
        </a-col>
      </a-row>
      <a-row v-if="feedbackData.after_list.length>0">
        <a-col
          :span="6"
          class="feed-title"
        >
          会后调研
        </a-col>
        <a-col :span="18">
          <div
            v-for="(item, index) in feedbackData.after_list"
            :key="index"
            class="questionItem"
          >
            <div class="question">
              {{ index + 1 }}.{{ item.survey_name }}
            </div>

            答案：<span class="answer">{{ item.answer.join('、') }}</span>
          </div>
        </a-col>
      </a-row>
    </div>
  </a-modal>
</template>
<script>
export default {
  props: ['feedbackData', 'visible' ],
  data() {
    return {
    };
  },
  mounted() {},
  methods: {
  },
};
</script>
<style lang="scss" scoped>
.feedbackwrapper{
    height: 500px;
    overflow-y: scroll;
    .feed-title{
      font-size: 16px;
      font-weight: 600;
     padding-left: 20px;
    }
  }
  .questionItem{
    margin-bottom: 10px;
  }
  .question{
    color: rgb(19, 13, 13);
    font-size: 16px;
  }
  .answer{
    color:#666
  }
</style>